module.exports = __webpack_public_path__ + "img/frame_courses.eecde733.webp";